import styled from "styled-components";

export const CardsSc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 30px;

  .card {
    background: linear-gradient(to bottom, #f7f7f7, #e7e7e7);
    border: none;
    border-radius: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: opacity 0.2s ease-in-out;
  }

  .card:hover {
    opacity: 0.8;
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 30px;
    font-size: 1rem;
    font-weight: bold;
    color: #333333;
  }
`;
